module.exports = __webpack_public_path__ + "img/Checkbox-On_16px_2_Icon.c1d9592d.svg";